import { HttpClient } from '../../httpClient'
import { queryString } from '../../httpClient/queryString'
import type {
  OpalApi,
  OpalApiResponseDocument,
  OpalApiRequestParams,
} from '../../schema'

type ReadBoardsV3 = OpalApi<'ReadBoardsV3', 200>

export const readBoards: ReadBoardsV3 = async ({
  params,
}: Parameters<ReadBoardsV3>[0] = {}) => {
  const url = new URL('/boards/v3', window.location.origin)

  url.search = queryString(params?.query)

  return HttpClient()
    .get(url.toString())
    .then((res) => res.data)
}

type ReadBoardOperation = 'ReadBoardV3'

export type ReadBoardResponse = OpalApiResponseDocument<ReadBoardOperation, 200>

export async function readBoard(
  params: OpalApiRequestParams<ReadBoardOperation>
): Promise<ReadBoardResponse> {
  const url = new URL(
    `/boards/v3/${params.path.board_id}`,
    window.location.origin
  )

  url.search = queryString(params.query)

  return HttpClient()
    .get(url.toString())
    .then((res) => res.data)
}
